import { gql } from 'apollo-boost';
import { useMutation } from '../';

export const updateUser = gql`
  mutation updateUser(
    $id: Int!,
    $firstName: String,
    $lastName: String,
    $enabled: Int,
    $title: String,
    $pronoun: String,
    $phone: String,
    $userType: String
  ) {
  updateUser(
    id: $id,
    firstName: $firstName,
    lastName: $lastName,
    enabled: $enabled,
    title: $title,
    pronoun: $pronoun,
    phone:$phone,
    userType: $userType
  ) {
      success
    }
  }
`;

export function useUpdateUser() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(updateUser, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };
  return { data, isLoading, run };
}
